var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.896,
    height: 13.355,
    viewBox: "0 0 16.896 13.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -3.044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.528,10.063a.528.528,0,0,1,.528.528v3.7a1.056,1.056,0,0,0,1.056,1.056H14.784a1.056,1.056,0,0,0,1.056-1.056v-3.7a.528.528,0,0,1,1.056,0v3.7A2.112,2.112,0,0,1,14.784,16.4H2.112A2.112,2.112,0,0,1,0,14.287v-3.7a.528.528,0,0,1,.528-.528ZM5.28,6.741a.528.528,0,0,0,.747,0L8.448,4.319,10.869,6.74a.528.528,0,1,0,.747-.746L8.821,3.2a.528.528,0,0,0-.748,0L5.28,5.994a.528.528,0,0,0,0,.748Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,4.5a.528.528,0,0,1,.528.528v8.448a.528.528,0,1,1-1.056,0V5.028A.528.528,0,0,1,17.4,4.5Z",
    transform: "translate(-8.955 -0.772)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.dc666f30d392fa9c5ec4844870cc957a.svg";
export { ForwardRef as ReactComponent };